export default __webpack_public_path__ + "static/media/1.cecf7c48.png";